/**
 * Created by liux on 17/12/30.
 */
import './reporter'
import $ from 'bjxy-common/helper/domEvent'
import {parse,realType} from 'bjxy-common/helper/utils';

export default function (initData={}) {
  window.xy_bj_reporter.init(initData);
  if(initData.cmdid && initData.buttonid !== undefined){
    $(report.bind(null,initData))
  }
  function report(data) {
    if(realType(data) !== 'object')return;
    if (window.xy_bj_reporter){
      return window.xy_bj_reporter.report(data)
    }
    return {then:function() {}}
  }
  report.init = function(initData={}) {
    window.xy_bj_reporter.init(...arguments);
    if(initData.cmdid && initData.buttonid !== undefined){
      report(initData)
    }
  }

  function getData(){
    var data = $(this).data('report')[0];
    data = parse(data)
    if(!data || realType(data) !== 'object'){
      return ''
    }
    return data
  }
  $(document).on('click','[data-report]:not(textarea):not(input)',function() {
    report(getData.call(this))
  }).on('change','[data-report]',function() {
    var data = getData.call(this)
    var key = $(this).data('key')[0];
    if(data && key){
      var val = this.value
      data[key] = val
    }
    report(data)
  }).on('click','input[data-report][type="button"]',function() {
    report(getData.call(this))
  }).on('click','input[data-report][type="submit"]',function() {
    report(getData.call(this))
  })

  return report
}
